<template>
  <div class="d-theme-dark-bg">
    
    <vs-popup class="holamundo" title="Add New Package" :active.sync="popupActivo">
        <vx-input-group class="mb-3">
                <ul class="con-s">
                    <li>
                        <label for="">Active</label>
                        <vs-switch v-model="pkg.status" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                    <li>
                        <label for="">Featured Package</label>
                        <vs-switch v-model="pkg.featured" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                </ul>
            </vx-input-group>
      <vx-input-group class="mb-3">
        <vs-input v-model="pkg.name" placeholder="Package Name" />
      </vx-input-group>
      <vx-input-group class="mb-3">
        <vs-input v-model="pkg.ar_name" placeholder="Arabic Name" />
      </vx-input-group>
      <vx-input-group class="mb-3">
        Image:
        <input type="file" class="form-control-file" ref="image" v-on:change="handleImage()">
      </vx-input-group>
      <vx-input-group class="mb-3">
        Secondary Image:
        <input type="file" class="form-control-file" ref="secImage" v-on:change="handleSecondaryImage()">
      </vx-input-group>
      <vx-input-group class="mb-3">
        <vs-button color="warning" type="filled" @click="addPackage">Save</vs-button>
      </vx-input-group>
    </vs-popup>

    <vs-button @click="popupActivo = true">Add Package</vs-button> <br />
    <br />
     
    <vs-collapse type="border"  :open="false">
      <draggable v-model="packages" group="people" @end="updateSequence" >
        <transition-group>
          <vs-collapse-item v-for="pack in packages" :key="pack.id" v-if="pack" :open="false">
            <div slot="header" class="flex">
              <vs-button radius color="danger" type="filled" icon="delete" size="small" @click="openConfirm(pack)"></vs-button>
              <vs-button class="mx-1" radius color="warning" type="filled" icon="edit" size="small" @click="editPackage(pack)"></vs-button>
              <span class="mx-3">{{ pack.name }}</span>

            </div>
            <channels :pkg="pack" />
             
          </vs-collapse-item>
        </transition-group>
      </draggable>
    </vs-collapse>
  </div>
</template>
<script>
  /* eslint-disable */
  import draggable from "vuedraggable";
  import channels from '../../components/TvChannels.vue'
  export default {
    components: {
      draggable,channels
    },

    data() {
      return {
        popupActivo: false,
        pkg: {
          id:0,
          name: "",
          ar_name: "",
          image: "",
          secondary_image: "",
          featured: 0,
          status: 1,
        },
        packages: [],
      };
    },
    created() {
      this.$store.dispatch("Tv/fetchPackages", {
        page: 1,
      });
      setTimeout(() => {
        this.packages = this.$store.state.Tv.packages;
      }, 100);
    },

    computed: {
      count() {
        return this.$store.state.Tv.packages
        // Or return basket.getters.fruitsCount
        // (depends on your design decisions).
      }
    },
    watch: {
      count(newCount, oldCount) {
        this.packages = this.$store.state.Tv.packages;
      }
    },
    methods: {
      updateSequence() {
        var ids = [];
        for (let index = 0; index < this.packages.length; index++) {
          const element = this.packages[index];
          ids.push(element.id);
        }
        this.$store.dispatch("Tv/updatePackagesSequence", {
          data: ids,
        });
      },
      editPackage(pack){
          this.popupActivo=true;
          this.pkg=pack;
      },
      addPackage() {
       this.$vs.loading();
        const data = new FormData();
        data.append('id', this.pkg.id);
        data.append('name', this.pkg.name);
        data.append('ar_name', this.pkg.ar_name);
        data.append('featured', this.pkg.featured?1:0);
        data.append('status', this.pkg.status?1:0);
        if (typeof this.pkg.image != 'string' || !this.pkg.image instanceof String){
         data.append('image', this.pkg.image); 
        }
        if (typeof this.pkg.secondary_image != 'string' || !this.pkg.secondary_image instanceof String){
          data.append('secondary_image', this.pkg.secondary_image);
        }
        
       
        this.axios.post(`${this.$apiUrl}/v2/tv/packages`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          this.$vs.loading.close();

          this.$vs.notify({
            color: 'success',
            title: 'Package Addedd',
            text: ''
          })


          this.$store.dispatch("Tv/fetchPackages", {
            page: 1,
          });
          this.packages = this.$store.state.Tv.packages;
        }).catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: 'danger',
            title: 'Error When Add',
            text: ''
          })
        });
        this.popupActivo = false;

      },
      handleImage() {
        this.pkg.image = this.$refs.image.files[0];
      },
      handleSecondaryImage() {
        this.pkg.secondary_image = this.$refs.secImage.files[0];
      },
      openConfirm(pkg) {
                this.pkg=pkg;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete Package`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
      del(id) {
        this.axios.post(`${this.$apiUrl}/v2/tv/packages/${this.pkg.id}/del`).then(res => {
          this.pkg = {
            id:0,
            name: "",
            ar_name: "",
            image: "",
            secondary_image: "",
          };
          if (res.status == 200) {
            this.$vs.notify({
              color: 'warning',
              title: 'Package Deleted !',
              text:''
            })
          }
          this.$store.dispatch("Tv/fetchPackages", {
            page: 1,
          });
          this.packages = this.$store.state.Tv.packages;
        })

      },
    },
  };
</script>